import React from "react";
import moment from "moment";
import { Controller } from "react-hook-form";
import SignatureCanvas from "react-signature-canvas";
import { QuestionMarkCircleIcon } from "@heroicons/react/solid";
import {
  convertLabelIntoName,
  dynamicFormDateValidation,
  findStoredFormSignature,
  getError,
  getExtensionName,
  parseBooleanVal,
  resolveDynamicFieldKey,
  signatureImageSrc,
  visibleFormHtml,
} from "Utils/utils";
import {
  getRequiredTableError,
  TABLE_REQUIRED_FIELD_NAME,
} from "Utils/dynamicFormTableValidation";
import { FiPlus } from "react-icons/fi";
import CustomButton from "components/common/Button/CustomButton";
import {
  REGEX_PHONE_NUMBER,
  STATE_FULL_LABEL_OPTIONS,
} from "Constants/constant";
import {
  FormReadOnlyChoice,
  FormReadOnlyField,
  FormReadOnlyTable,
} from "../shared/FormReadOnlyField";
import { previewFieldPlaceholder } from "../shared/formBuilderConstants";

const assignSignatureCanvasRef = (sigCanvasManager, key, element) => {
  if (!sigCanvasManager?.current || !key) return;
  if (!sigCanvasManager.current[key]) {
    sigCanvasManager.current[key] = { current: null };
  }
  sigCanvasManager.current[key].current = element;
};

const SubSectionInputFields = (props) => {
  const {
    isViewable,
    previewMode = false,
    field,
    i,
    register,
    index,
    errors,
    fileUploadHandler,
    fileUploadChecker,
    fileLoader,
    signatures,
    control,
    clearSignatureManager,
    sigCanvasManager,
    formatIntoPngManager,
    watchFormData,
    setSelectedLegal,
    addRowHandler,
    delteRowHandler,
    handleAddOther,
    handleRemoveOther,
    checkIsDependent,
    setValue = null,
  } = props;

  return (
    <>
      <div className='form-subsection col-span-12'>
        <div className='form-subsection-header'>
          <p className='form-subsection-title'>{field.section_title}</p>
          {!previewMode &&
            handleAddOther &&
            parseBooleanVal(field.isAddOther) && (
            <div>
              <CustomButton
                label='Add another'
                type='button'
                // cssClass='mr-3'
                clickHandler={() => handleAddOther(index, i)}
              />
            </div>
          )}
          {!previewMode &&
            handleRemoveOther &&
            field.hasOwnProperty("isAddOtherDelete") &&
            parseBooleanVal(field.isAddOtherDelete) && (
              <button
                type='button'
                className='form-remove-other-btn'
                onClick={() => handleRemoveOther(index, i)}
              >
                Remove entry
              </button>
            )}
        </div>
        <div className='form-subsection-body form-field-grid'>
        {field?.sub_fields.length > 0 &&
          field?.sub_fields.map((item, sf) => {
            const isReadOnlyView = register === null && isViewable;

            // if (item.type === "content" && checkIsDependent(item)) {
            //   return (
            //     <div
            //       key={`${convertLabelIntoName(item.type)}-${sf}`}
            //       className={`col-span-12 flex flex-col`}
            //     >
            //       {item.hasOwnProperty("content") && item.content && (
            //         <div
            //           // className="text-xs text-gray-600 rounded-lg px-2 py-2"
            //           className='py-2 border p-4 rounded-lg'
            //           dangerouslySetInnerHTML={{
            //             __html: item.content,
            //           }}
            //         />
            //       )}
            //     </div>
            //   );
            // }
            if (item.type === "content" && checkIsDependent(item))
            {
              const contentHtml = visibleFormHtml(item.content);
              if (!contentHtml) return null;
              return (
                <div
                  key={`${convertLabelIntoName(item.type)}-${sf}`}
                  className="form-content-block ck-content col-span-12"
                  dangerouslySetInnerHTML={{
                    __html: contentHtml,
                  }}
                />
              );
            } else if (item.type === "checkbox" && checkIsDependent(item))
            {
              if (isReadOnlyView) {
                return (
                  <FormReadOnlyChoice
                    key={`${convertLabelIntoName(item.lable)}-${sf}`}
                    label={item.lable}
                    selectedValue={item.value}
                    fullWidth={parseBooleanVal(item.isFullWidth)}
                    hint={item.hint}
                    type='checkbox'
                  />
                );
              }

              const checkboxId = `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                item.lable
              )}`;

              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                    parseBooleanVal(item.isFullWidth)
                      ? "col-span-12"
                      : "col-span-12 md:col-span-6"
                  }`}
                >
                  <div className='form-checkbox-card'>
                    <input
                      {...register(
                        `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                          item.lable
                        )}`,
                        {
                          required: parseBooleanVal(item.required),
                          value: item.value,
                        }
                      )}
                      type='checkbox'
                      id={checkboxId}
                    />
                    <label htmlFor={checkboxId}>{item.lable}</label>
                  </div>
                  {item.hasOwnProperty("hint") && item.hint && (
                    <div
                      className='form-field-hint'
                      dangerouslySetInnerHTML={{ __html: item.hint }}
                    />
                  )}
                  {!isViewable && getError(errors, item.lable, index, i, sf)}
                </div>
              );
            } else if (item.type === "textarea" && checkIsDependent(item))
            {
              if (isReadOnlyView) {
                return (
                  <FormReadOnlyField
                    key={`${convertLabelIntoName(item.lable)}-${sf}`}
                    label={item.lable}
                    value={item.value}
                    fullWidth={parseBooleanVal(item.isFullWidth)}
                    hint={item.hint}
                    multiline
                  />
                );
              }

              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                    parseBooleanVal(item.isFullWidth)
                      ? "col-span-12"
                      : "col-span-12 md:col-span-6"
                  } did-floating-label-content`}
                >
                  <label className='did-floating-label text-sm'>
                    {item.lable}
                  </label>
                  <textarea
                    {...(register
                      ? register(
                          `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                            item.lable
                          )}`,
                          {
                            required: parseBooleanVal(item.required),
                            value: item.value,
                          }
                        )
                      : {
                          value: item.value,
                          readOnly: true,
                          disabled: true,
                        })}
                    className='form-textarea'
                    rows={4}
                    placeholder={
                      previewMode ? previewFieldPlaceholder("textarea") : undefined
                    }
                    readOnly={previewMode || undefined}
                  />
                  {!isViewable && getError(errors, item.lable, index, i, sf)}
                  {item.hasOwnProperty("hint") && item.hint && (
                    <div
                      className='form-field-hint'
                      dangerouslySetInnerHTML={{ __html: item.hint }}
                    />
                  )}
                </div>
              );
            } else if (item.type === "file" && checkIsDependent(item))
            {
              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                      parseBooleanVal(item.isFullWidth)
                          ? "col-span-12"
                          : "col-span-12 md:col-span-6"
                  } did-floating-label-content`}
                >
                  <label className='did-floating-label text-sm'>
                    {item.lable}
                  </label>
                  {register === null && isViewable && (
                    <div className='mt-1'>
                      <p className='text-sm text-gray-500 truncate'>
                        {item.value}
                      </p>
                      <a
                        href={item.path}
                        download
                        target='_blank'
                        className='inline-block mt-1 cursor-pointer bg-gradient text-white font-bold py-1 px-4 rounded print:hidden'
                        rel='noreferrer'
                      >
                        {`${getExtensionName(item.path)}`}
                      </a>
                    </div>
                  )}
                  {register !== null && (
                    <>
                      <input
                        {...(register
                          ? register(
                              `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                                item.lable
                              )}`,
                              {
                                required:
                                  parseBooleanVal(item.required) && !item.value
                                    ? true
                                    : false,
                                onChange: (e) => {
                                  fileUploadHandler(e, index, i, sf);
                                },
                                value: item.value
                                  ? [new File([Blob], "file")]
                                  : null,
                              }
                            )
                          : {
                              readOnly: true,
                              disabled: true,
                            })}
                        type='file'
                        id={`template[${index}].input_fields[${i}].sub_section[${sf}].${item.name}`}
                        style={{
                          display: "none",
                        }}
                      />
                      <div className='did-floating-input'>
                        <div className='flex justify-between items-center h-full'>
                          <label
                            htmlFor={`template[${index}].input_fields[${i}].sub_section[${sf}].${item.name}`}
                            className='cursor-pointer bg-gradient p-1 rounded text-white p-0.5 whitespace-nowrap'
                          >
                            {item.value
                              ? "Change file"
                              : "Click me to upload file"}
                          </label>
                          {item.value && (
                            <p
                              style={{ whiteSpace: "pre" }}
                              className='pl-2 truncate'
                              title={item.value}
                            >
                              {item.value}
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {!isViewable && getError(errors, item.lable, index, i, sf)}
                  {!fileUploadChecker &&
                    fileLoader === `${index}-${i}-${sf}` && <h1>Loading</h1>}
                  {item.hasOwnProperty("hint") && item.hint && (
                      <div
                          className='text-xs text-gray-600 rounded-lg px-2 py-2'
                          dangerouslySetInnerHTML={{
                            __html: item.hint,
                          }}
                      />
                  )}
                </div>
              );
            } else if (item.type === "signature" && checkIsDependent(item))
            {
              const signatureKey = item.name;
              const labelKey = resolveDynamicFieldKey(item, sf);
              const storedSignature = findStoredFormSignature(
                signatures,
                signatureKey,
                labelKey
              );
              const signatureValidationKey =
                labelKey === signatureKey ? `${signatureKey}__signed` : labelKey;

              if (previewMode) {
                return (
                  <div
                    key={`${convertLabelIntoName(item.lable)}-${sf}`}
                    className={`${
                      parseBooleanVal(item.isFullWidth)
                        ? "col-span-12"
                        : "col-span-12 md:col-span-6"
                    } form-signature-block flex flex-col`}
                  >
                    <label className="did-floating-label text-sm">{item.lable}</label>
                    <div className="form-signature-display-inner">
                      <div className="form-signature-empty">Sign here</div>
                    </div>
                  </div>
                );
              }

              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                      parseBooleanVal(item.isFullWidth)
                          ? "col-span-12"
                          : "col-span-12 md:col-span-6"
                  } bg-white border rounded-lg shadow px-8 flex flex-col mb-6`}
                >
                  <div className='flex flex-col py-2'>
                    <p className='font-bold text-green-700'>Signatures</p>
                  </div>
                  <div className='flex flex-col lg:flex-row justify-between items-center'>
                    <div className=' flex flex-col text-gray-500 py-2 '>
                      <p className='did-floating-label text-sm pb-2'>
                        {item.lable}
                      </p>
                      {storedSignature ? (
                        <>
                          <img
                            src={signatureImageSrc(storedSignature.image)}
                            alt='signature'
                            className='h-auto w-auto sigCanvas border rounded-lg bg-gray-100'
                          />
                          {register && parseBooleanVal(item.required) && (
                            <input
                              type='hidden'
                              {...register(`${signatureValidationKey}`, {
                                required: parseBooleanVal(item.required),
                              })}
                              defaultValue='signature-added'
                            />
                          )}
                        </>
                      ) : (
                        register && (
                          <>
                            <Controller
                              name={item.name}
                              control={control}
                              render={({ field: controllerField }) => (
                                <SignatureCanvas
                                  ref={(ef) =>
                                    assignSignatureCanvasRef(
                                      sigCanvasManager,
                                      signatureKey,
                                      ef
                                    )
                                  }
                                  onEnd={() => {
                                    const payload = formatIntoPngManager(
                                      signatureKey,
                                      index,
                                      i,
                                      sf,
                                      labelKey
                                    );
                                    if (!payload?.image) return;
                                    controllerField.onChange(payload);
                                    if (setValue) {
                                      setValue(
                                        signatureValidationKey,
                                        "signature-added",
                                        { shouldValidate: true }
                                      );
                                    }
                                  }}
                                  penColor='green'
                                  canvasProps={{
                                    width: "auto",
                                    height: "auto",
                                    className:
                                      "sigCanvas border rounded-lg bg-gray-100 h-auto w-auto",
                                  }}
                                />
                              )}
                            />
                            <input
                              className='hidden sr-only'
                              {...register(`${signatureValidationKey}`, {
                                required: parseBooleanVal(item.required),
                              })}
                            />
                            {errors?.[`${signatureValidationKey}`]
                              ?.type === "required" && (
                              <span className='text-sm text-red-500'>
                                This field is required!
                              </span>
                            )}
                          </>
                        )
                      )}
                      {register && (
                        <div
                          onClick={() =>
                            clearSignatureManager(
                              signatureKey,
                              signatureValidationKey,
                              labelKey
                            )
                          }
                        >
                          <p className='flex items-center mt-1 cursor-pointer'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-6 w-6'
                              fill='none'
                              viewBox='0 0 24 24'
                              stroke='currentColor'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth='2'
                                d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'
                              />
                            </svg>
                            {storedSignature ? "update" : "clear"}
                          </p>
                        </div>
                      )}
                      {item.hasOwnProperty("hint") && item.hint && (
                          <div
                              className='text-xs text-gray-600 rounded-lg px-2 py-2'
                              dangerouslySetInnerHTML={{
                                __html: item.hint,
                              }}
                          />
                      )}
                    </div>
                  </div>
                </div>
              );
            } else if (item.type === "date" && checkIsDependent(item))
            {
              if (isReadOnlyView) {
                return (
                  <FormReadOnlyField
                    key={`${convertLabelIntoName(item.lable)}-${sf}`}
                    label={item.lable}
                    value={item.value}
                    fullWidth={parseBooleanVal(item.isFullWidth)}
                    hint={item.hint}
                  />
                );
              }

              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                    parseBooleanVal(item.isFullWidth)
                      ? "col-span-12"
                      : "col-span-12 md:col-span-6"
                  } did-floating-label-content`}
                >
                  <label htmlFor='' className='did-floating-label text-sm'>
                    {item.lable}
                  </label>
                  <input
                    {...(register
                      ? register(
                          `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                            item.lable
                          )}`,
                          {
                            required: parseBooleanVal(item.required),
                            value: item.value,
                            pattern: dynamicFormDateValidation(
                              item,
                              watchFormData,
                              index,
                              i,
                              sf
                            ),
                          }
                        )
                      : {
                          value: item.value,
                          readOnly: true,
                          disabled: true,
                        })}
                    type='date'
                    className='did-floating-input'
                    min={moment().format("DD-MM-YYYY")}
                  />
                  {!isViewable && getError(errors, item.lable, index, i, sf)}
                  {errors?.template?.[index]?.input_fields?.[i]?.sub_section[
                    sf
                  ]?.[`${convertLabelIntoName(item.lable)}`]?.type ===
                    "pattern" && (
                    <span className='text-sm text-red-500'>
                      {dynamicFormDateValidation(
                        item,
                        watchFormData,
                        index,
                        i,
                        sf,
                        false
                      )}
                    </span>
                  )}
                  {item.hasOwnProperty("hint") && item.hint && (
                      <div
                          className='text-xs text-gray-600 rounded-lg px-2 py-2'
                          dangerouslySetInnerHTML={{
                            __html: item.hint,
                          }}
                      />
                  )}
                </div>
              );
            } else if (item.type === "text" && checkIsDependent(item))
            {
              if (isReadOnlyView) {
                return (
                  <FormReadOnlyField
                    key={`${convertLabelIntoName(item.lable)}-${sf}`}
                    label={item.lable}
                    value={item.value}
                    fullWidth={parseBooleanVal(item.isFullWidth)}
                    hint={item.hint}
                  />
                );
              }

              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                    parseBooleanVal(item.isFullWidth)
                      ? "col-span-12"
                      : "col-span-12 md:col-span-6"
                  } did-floating-label-content print:mt-3`}
                >
                  <div className='relative'>
                    <label className='did-floating-label truncate-text text-sm'>
                    {item.lable}
                    </label>
                    <input
                      {...register(
                        `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                          item.lable
                        )}`,
                        {
                          required: parseBooleanVal(item.required),
                          value: item.value,
                        }
                      )}
                      type='text'
                      className='did-floating-input'
                    />
                    {item?.legalRef && (
                      <div
                        style={{
                          top: "22px",
                        }}
                        className='absolute inset-y-0 right-0 pr-3 flex items-center '
                      >
                        <span
                          onClick={() => setSelectedLegal(item.legalRef)}
                          role='button'
                          tabIndex='0'
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <QuestionMarkCircleIcon
                            className='h-5 w-5 text-gray-400'
                            aria-hidden='true'
                          />
                        </span>
                      </div>
                    )}
                  </div>

                  {item.hasOwnProperty("hint") && item.hint && (
                    <div
                      className=' text-sm text-gray-600 rounded-lg px-2 py-2'
                      dangerouslySetInnerHTML={{
                        __html: item.hint,
                      }}
                    />
                  )}
                  {!isViewable && getError(errors, item.lable, index, i, sf)}
                 
                </div>
              );
            } else if (item.type === "radio" && checkIsDependent(item))
            {
              if (isReadOnlyView) {
                return (
                  <FormReadOnlyChoice
                    key={`${convertLabelIntoName(item.lable)}-${sf}`}
                    label={item.lable}
                    options={item.options}
                    selectedValue={item.value}
                    fullWidth={parseBooleanVal(item.isFullWidth)}
                    hint={item.hint}
                    type='radio'
                  />
                );
              }

              const radioFieldName = `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                item.lable
              )}`;

              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                    parseBooleanVal(item.isFullWidth)
                      ? "col-span-12"
                      : "col-span-12 md:col-span-6"
                  } flex flex-col did-floating-label-content`}
                >
                  <label className='did-floating-label text-sm'>
                    {item.lable}
                  </label>
                  <div className='form-radio-pills'>
                    {item.options.map((option, oi) => {
                      const optionId = `${radioFieldName}.${option.lable}`;
                      return (
                        <div key={oi} className='form-radio-pill'>
                          <input
                            {...register(radioFieldName, {
                              required: parseBooleanVal(item.required),
                              value: item.value ? item.value : option.lable,
                            })}
                            id={optionId}
                            value={option.lable}
                            type='radio'
                          />
                          <label htmlFor={optionId}>{option.lable}</label>
                        </div>
                      );
                    })}
                  </div>
                  {!isViewable && getError(errors, item.lable, index, i, sf)}
                  {item.hasOwnProperty("hint") && item.hint && (
                    <div
                      className='form-field-hint'
                      dangerouslySetInnerHTML={{ __html: item.hint }}
                    />
                  )}
                </div>
              );
            } else if (item.type === "select" && checkIsDependent(item))
            {
              if (isReadOnlyView) {
                return (
                  <FormReadOnlyField
                    key={`${convertLabelIntoName(item.lable)}-${sf}`}
                    label={item.lable}
                    value={item.value}
                    fullWidth={parseBooleanVal(item.isFullWidth)}
                    hint={item.hint}
                  />
                );
              }

              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                    parseBooleanVal(item.isFullWidth)
                      ? "col-span-12"
                      : "col-span-12 md:col-span-6"
                  } flex flex-col did-floating-label-content`}
                >
                  <label className='did-floating-label truncate-text text-sm'>
                    {item.lable}
                  </label>
                  <select
                    {...register(
                      `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                        item.lable
                      )}`,
                      {
                        required: parseBooleanVal(item.required),
                        value: item.value,
                      }
                    )}
                    id=''
                    className='did-floating-select'
                  >
                    {item.options.map((option, oi) => {
                      return (
                        <option value={option.lable} key={oi}>
                          {option.lable}
                        </option>
                      );
                    })}
                  </select>
                  {!isViewable && getError(errors, item.lable, index, i, sf)}
                  {item.hasOwnProperty("hint") && item.hint && (
                      <div
                          className='text-xs text-gray-600 rounded-lg px-2 py-2'
                          dangerouslySetInnerHTML={{
                            __html: item.hint,
                          }}
                      />
                  )}
                </div>
              );
            } else if (item.type === "table" && checkIsDependent(item))
            {
              if (isReadOnlyView) {
                return (
                  <FormReadOnlyTable
                    key={`${convertLabelIntoName(item.lable)}-${sf}`}
                    label={item.lable}
                    columns={item.columns ?? []}
                    rows={item.rows ?? []}
                    hint={item.hint}
                  />
                );
              }

              const hasRows =
                item.hasOwnProperty("rows") && item.rows.length > 0;

              const tableError = getRequiredTableError(
                watchFormData?.template?.[index]?.input_fields?.[i]
                  ?.sub_fields?.[sf],
                item.columns
              );
              const isWideTable = (item?.columns?.length ?? 0) >= 7;
              const wideTableClass = isWideTable
                ? " form-dynamic-table--wide"
                : "";
              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className='form-dynamic-table-field flex flex-col min-w-0 max-w-full w-full'
                >
                  <label
                    htmlFor=''
                    className='did-floating-label truncate-text text-sm'
                  >
                    {item.lable}
                  </label>
                  <div className='flex flex-col min-w-0 max-w-full w-full'>
                    <div className='form-table-wrapper mt-2 w-full min-w-0 max-h-[420px] overflow-auto custom-scroll'>
                      <table
                        className={`form-table form-dynamic-table form-table-cards print:table-fixed${wideTableClass}`}
                      >
                        <thead>
                          <tr>
                            {!isViewable && (
                              <th scope='col' className='form-table-row-index print:hidden'>
                                #
                              </th>
                            )}
                            {item?.columns.map((citem, a) => (
                              <th
                                key={`${convertLabelIntoName(
                                  citem.lable
                                )}-${a}`}
                                scope='col'
                                className='table-col-min-width'
                              >
                                {citem.lable}
                              </th>
                            ))}
                            {!isViewable && (
                              <th
                                scope='col'
                                className='form-table-actions-col print:hidden'
                              >
                                Remove
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {!hasRows && !isViewable ? (
                            <tr className='form-table-empty-row'>
                              <td colSpan={(item?.columns?.length || 0) + 2}>
                                <div className='form-table-empty-state'>
                                  <p>No line items yet</p>
                                  <span className='form-table-empty-cta'>
                                    Use &ldquo;Add row&rdquo; to add your first entry
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            item?.rows.map((row, ri) => {
                              return (
                                <tr key={ri}>
                                  {!isViewable && (
                                    <td className='form-table-row-index print:hidden'>
                                      {ri + 1}
                                    </td>
                                  )}
                                  {row?.map((col, ci) => {
                                    if (col.type === "select") {
                                      return (
                                        <td
                                          key={`${convertLabelIntoName(
                                            col.lable
                                          )}-${ci}`}
                                          data-label={col.lable}
                                          className='table-col-min-width'
                                        >
                                          <select
                                            {...(register
                                              ? register(
                                                  `template[${index}].input_fields[${i}].sub_fields[${sf}].rows[${ri}].columns[${ci}].${convertLabelIntoName(
                                                    col.lable
                                                  )}`,
                                                  {
                                                    required: parseBooleanVal(
                                                      col.required
                                                    ),
                                                    value: col.value,
                                                  }
                                                )
                                              : {
                                                  value: col.value,
                                                  readOnly: true,
                                                  disabled: true,
                                                })}
                                            key={ci}
                                            id=''
                                            className='form-table-cell-input'
                                            style={{
                                              border: "1px solid #ebe8e8",
                                            }}
                                          >
                                            {col.options.map((option, co) => {
                                              return (
                                                <option
                                                  key={co}
                                                  value={option.lable}
                                                >
                                                  {option.lable}
                                                </option>
                                              );
                                            })}
                                          </select>
                                        </td>
                                      );
                                    } else if (col.type === "checkbox") {
                                      return (
                                        <td
                                          key={`${convertLabelIntoName(
                                            col.lable
                                          )}-${ci}`}
                                          data-label={col.lable}
                                          className='table-col-min-width print:break-all print:p-2 print:border print:border-solid print:border-gray-200'
                                        >
                                          <div className='w-8 mx-auto'>
                                            <input
                                              {...(register
                                                ? register(
                                                    `template[${index}].input_fields[${i}].sub_fields[${sf}].rows[${ri}].columns[${ci}].${convertLabelIntoName(
                                                      col.lable
                                                    )}`,
                                                    {
                                                      required: parseBooleanVal(
                                                        col.required
                                                      ),
                                                      value: col.value
                                                        ? col.value
                                                        : "",
                                                    }
                                                  )
                                                : {
                                                    value: col.value
                                                      ? col.value
                                                      : "",
                                                    readOnly: true,
                                                    disabled: true,
                                                  })}
                                              type='checkbox'
                                              checked={col.value}
                                              style={{
                                                border: "1px solid #ebe8e8",
                                              }}
                                              className='form-table-cell-input accent-[#4b6cb7]'
                                            />
                                          </div>
                                        </td>
                                      );
                                    } else {
                                      return (
                                        <td
                                          key={`${convertLabelIntoName(
                                            col.lable
                                          )}-${ci}`}
                                          data-label={col.lable}
                                          className='table-col-min-width print:break-all print:p-2 print:border print:border-solid print:border-gray-200'
                                        >
                                          <div className='hidden print:block text-left print:break-all'>
                                            {col.value}
                                          </div>
                                          <input
                                            {...(register
                                              ? register(
                                                  `template[${index}].input_fields[${i}].sub_fields[${sf}].rows[${ri}].columns[${ci}].${convertLabelIntoName(
                                                    col.lable
                                                  )}`,
                                                  {
                                                    required: parseBooleanVal(
                                                      col.required
                                                    ),
                                                    value: col.value
                                                      ? col.value
                                                      : "",
                                                  }
                                                )
                                              : {
                                                  value: col.value
                                                    ? col.value
                                                    : "",
                                                  readOnly: true,
                                                  disabled: true,
                                                })}
                                            type='text'
                                            style={{
                                              border: "1px solid #ebe8e8",
                                            }}
                                            className='form-table-cell-input block print:hidden'
                                          />
                                        </td>
                                      );
                                    }
                                  })}
                                  {/* <div className='pagebreak' /> */}
                                  {!isViewable && (
                                    <td className='form-table-actions-col print:hidden'>
                                      <button
                                        type='button'
                                        onClick={() =>
                                          delteRowHandler(index, i, ri, sf)
                                        }
                                        className='form-table-delete-btn'
                                        aria-label={`Remove row ${ri + 1}`}
                                      >
                                        Remove
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className='pagebreak'></div>
                    {!isViewable && (
                      <div className='flex justify-start items-center mt-2'>
                        <button
                          type='button'
                          onClick={() => addRowHandler(index, i, sf)}
                          className='form-table-add-row'
                        >
                          <FiPlus />
                          <span>Add row</span>
                        </button>
                      </div>
                    )}
                    {!isViewable && register && parseBooleanVal(item.required) && (
                      <>
                        <input
                          type='text'
                          readOnly
                          tabIndex={-1}
                          className='sr-only'
                          {...register(
                            `template[${index}].input_fields[${i}].sub_fields[${sf}].${TABLE_REQUIRED_FIELD_NAME}`,
                            {
                              validate: () => (tableError ? tableError : true),
                            }
                          )}
                        />
                        {tableError &&
                          errors?.template?.[index]?.input_fields?.[i]
                            ?.sub_fields?.[sf]?.[
                            TABLE_REQUIRED_FIELD_NAME
                          ] && (
                            <span className='text-sm text-red-500 text-left'>
                              {tableError}
                            </span>
                          )}
                      </>
                    )}
                  </div>
                  {item.hasOwnProperty("hint") && item.hint && (
                      <div
                          className='text-xs text-gray-600 rounded-lg px-2 py-2'
                          dangerouslySetInnerHTML={{
                            __html: item.hint,
                          }}
                      />
                  )}
                </div>
              );
            } else if (item.type === "phone" && checkIsDependent(item))
            {
             
              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`${
                    parseBooleanVal(item.isFullWidth)
                      ? "col-span-12"
                      : "col-span-12 md:col-span-6"
                  } flex flex-col did-floating-label-content`}
                >
                  <label className='did-floating-label text-sm'>
                    {item.lable}
                  </label>
                  <input
                    {...(register
                      ? register(
                          `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                            item.lable
                          )}`,
                          {
                            pattern: REGEX_PHONE_NUMBER,
                            onChange: (e) => {
                              const sanitizedValue = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              const formattedValue = sanitizedValue.slice(
                                0,
                                10
                              );
                              e.target.value = formattedValue;
                            },
                            value: item.value,
                            required: parseBooleanVal(item.required),
                  
                            maxLength: 10,
                          }
                        )
                      : {
                          value: item.value,
                          readOnly: true,
                          disabled: true,
                        })}
                    className='did-floating-input appearance-no'
                     type='text'
                    inputMode='numeric'
                    maxLength={10}
                    
                  />
                    {!isViewable && getError(errors, item.lable, index, i, sf)}
                  {errors?.template?.[index]?.input_fields?.[i]?.sub_section?.[
                    sf
                  ]?.[`${convertLabelIntoName(item.lable)}`]?.type === "minLength" && (
                    <span className='text-sm text-red-500'>
                      Phone number must have 10 digits
                    </span>
                  )}
                  {errors?.template?.[index]?.input_fields?.[i]?.sub_section?.[
                    sf
                  ]?.[`${convertLabelIntoName(item.lable)}`]?.type === "maxLength" && (
                    <span className='text-sm text-red-500'>
                      Phone number must have 10 digits
                    </span>
                  )}
                  {errors?.template?.[index]?.input_fields?.[i]?.sub_section?.[
                    sf
                  ]?.[`${convertLabelIntoName(item.lable)}`]?.type === "pattern" && (
                    <span className='text-sm text-red-500'>
                      Please enter a valid phone number!
                    </span>
                  )}
                  {item.hasOwnProperty("hint") && item.hint && (
                      <div
                          className='text-xs text-gray-600 rounded-lg px-2 py-2'
                          dangerouslySetInnerHTML={{
                            __html: item.hint,
                          }}
                      />
                  )}
                  {/* {!isViewable && getError(errors, item.lable, index, i, sf)}
                  {errors?.template?.[index]?.input_fields?.[i]?.sub_section[
                    sf
                  ][`${item.name}`]?.type === "minLength" && (
                    <span className='text-sm text-red-500'>
                      Phone number must have 10 digits
                    </span>
                  )}
                  {errors?.template?.[index]?.input_fields?.[i]?.sub_section[
                    sf
                  ][`${item.name}`]?.type === "maxLength" && (
                    <span className='text-sm text-red-500'>
                      Phone number must have 10 digits
                    </span>
                  )}
                  {errors?.template?.[index]?.input_fields?.[i]?.sub_section[
                    sf
                  ][`${item.name}`]?.type === "pattern" && (
                    <span className='text-sm text-red-500'>
                      Please enter a valid phone number!
                    </span>
                  )}
                  {item.hasOwnProperty("hint") && item.hint && (
                      <div
                          className='text-xs text-gray-600 rounded-lg px-2 py-2'
                          dangerouslySetInnerHTML={{
                            __html: item.hint,
                          }}
                      />
                  )} */}
                </div>
              );
            } else if (item.type === "address" && checkIsDependent(item))
            {
              return (
                <div
                  key={`${convertLabelIntoName(item.lable)}-${sf}`}
                  className={`col-span-12 flex flex-col did-floating-label-content print:mt-3`}
                >
                  <div className='grid grid-cols-4 space-x-4'>
                    <div className='col-span-2 md:col-span-1 did-floating-label-content'>
                      <label className='did-floating-label text-sm'>
                        Street Name
                      </label>
                      <div className='print:hidden'>
                        <input
                          {...(register
                            ? register(
                                `template[${index}].input_fields[${i}].sub_section[${sf}].address.street`,
                                {
                                  required: parseBooleanVal(item.required),
                                  value: item.hasOwnProperty("address")
                                    ? item?.address?.street
                                    : "",
                                }
                              )
                            : {
                                value: item.hasOwnProperty("address")
                                  ? item?.address?.street
                                  : "",
                                readOnly: true,
                                disabled: true,
                              })}
                          className='did-floating-input'
                          type='text'
                        />
                        {errors?.template?.[index]?.input_fields?.[i]
                          ?.sub_section?.[sf]?.address?.street?.type ===
                          "required" && (
                          <span className='text-sm text-red-500'>
                            This field is required!
                          </span>
                        )}
                      </div>
                      <div
                        className={`did-floating-input sectionInputViewPrint`}
                      >
                        {item.hasOwnProperty("address")
                          ? item?.address?.street
                          : ""}
                      </div>
                    </div>
                    <div className='col-span-2 md:col-span-1'>
                      <label className='did-floating-label text-sm'>
                        Suburb
                      </label>
                      <div className='print:hidden'>
                        <input
                          {...(register
                            ? register(
                                `template[${index}].input_fields[${i}].sub_section[${sf}].address.subrub`,
                                {
                                  required: item.required,
                                  value: item.hasOwnProperty("address")
                                    ? item?.address?.subrub
                                    : "",
                                }
                              )
                            : {
                                value: item.hasOwnProperty("address")
                                  ? item?.address?.subrub
                                  : "",
                                readOnly: true,
                                disabled: true,
                              })}
                          className='did-floating-input'
                          type='text'
                        />
                        {errors?.template?.[index]?.input_fields?.[i]
                          ?.sub_section?.[sf]?.address?.subrub?.type ===
                          "required" && (
                          <span className='text-sm text-red-500'>
                            This field is required!
                          </span>
                        )}
                      </div>
                      <div
                        className={`did-floating-input sectionInputViewPrint`}
                      >
                        {item.hasOwnProperty("address")
                          ? item?.address?.subrub
                          : ""}
                      </div>
                    </div>
                    <div className='col-span-2 md:col-span-1'>
                      <label className='did-floating-label text-sm'>
                        Postcode
                      </label>
                      <input
                        {...(register
                          ? register(
                              `template[${index}].input_fields[${i}].sub_section[${sf}].address.postcode`,
                              {
                                required: item.required,
                                value: item.hasOwnProperty("address")
                                  ? item?.address?.postcode
                                  : "",
                                // onChange: (e) => {
                                //   e.target.value = Math.max(
                                //     0,
                                //     parseInt(e.target.value)
                                //   )
                                //     .toString()
                                //     .slice(0, 4);
                                // },
                                onChange: (e) => {
                                  e.target.value = e.target.value
                                    .replace(/[^0-9]/g, "")
                                    .slice(0, 4);
                                },
                                minLength: 4,
                                maxLength: 4,
                              }
                            )
                          : {
                              value: item.hasOwnProperty("address")
                                ? item?.address?.postcode
                                : "",
                              readOnly: true,
                              disabled: true,
                            })}
                        className='did-floating-input'
                        type='number'
                      />
                      {(errors?.template?.[index]?.input_fields?.[i]
                              ?.sub_section?.[sf]?.address?.postcode?.type ===
                          "maxLength" ||
                          errors?.template?.[index]?.input_fields?.[i]
                              ?.sub_section?.[sf]?.address?.postcode?.type ===
                          "minLength") && (
                        <span className='text-sm text-red-500'>
                          This field is required!
                        </span>
                      )}
                      {(errors?.template?.[index]?.input_fields?.[i]
                        ?.sub_section?.[sf]?.address?.postcode?.type ===
                        "maxLength" ||
                        errors?.template?.[index]?.input_fields?.[i]
                          ?.sub_section?.[sf]?.address?.postcode?.type ===
                          "minLength") && (
                        <span className='text-sm text-red-500'>
                          Postcode must be 4 digits!
                        </span>
                      )}
                    </div>

                    <div className='col-span-2 md:col-span-1'>
                      <label className='did-floating-label text-sm'>
                        State
                      </label>
                      <select
                        className='did-floating-select'
                        {...(register
                          ? register(
                              `template[${index}].input_fields[${i}].sub_section[${sf}].address.state`,
                              {
                                required: item.required,
                                value: item.hasOwnProperty("address")
                                  ? item?.address?.state
                                  : "New south Wales",
                              }
                            )
                          : {
                              value: item.hasOwnProperty("address")
                                ? item?.address?.state
                                : "",
                              readOnly: true,
                              disabled: true,
                            })}
                      >
                        {STATE_FULL_LABEL_OPTIONS.map((option, state_index) => (
                          <option
                            key={`${state_index}-${option.value}`}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                      {errors?.template?.[index]?.input_fields?.[i]
                        ?.sub_scetion?.[sf]?.address?.state?.type ===
                        "required" && (
                        <span className='text-sm text-red-500'>
                          This field is required!
                        </span>
                      )}
                    </div>
                  </div>
                  {item.hasOwnProperty("hint") && item.hint && (
                      <div
                          className='text-xs text-gray-600 rounded-lg px-2 py-2'
                          dangerouslySetInnerHTML={{
                            __html: item.hint,
                          }}
                      />
                  )}
                </div>
              );
            } else {
              return (
                <>
                  {checkIsDependent(item) && (
                    <div
                      key={`${convertLabelIntoName(item.lable)}-${sf}`}
                      className={`${
                        parseBooleanVal(item.isFullWidth)
                          ? "col-span-12"
                          : "col-span-12 md:col-span-6"
                      } did-floating-label-content print:mt-3`}
                    >
                      <label
                        htmlFor=''
                        className='did-floating-label truncate-text text-sm'
                      >
                        {item.lable}
                      </label>
                      <div className='print:hidden'>
                        <input
                          {...(register
                            ? register(
                                `template[${index}].input_fields[${i}].sub_section[${sf}].${convertLabelIntoName(
                                  item.lable
                                )}`,
                                {
                                  required: parseBooleanVal(item.required),
                                  value: item?.value ?? "",
                                }
                              )
                            : {
                                value: item?.value ?? "",
                                readOnly: true,
                                disabled: true,
                              })}
                          type={item.type}
                          className='did-floating-input'
                          placeholder={
                            previewMode
                              ? previewFieldPlaceholder(item.type)
                              : undefined
                          }
                          readOnly={previewMode || undefined}
                        />
                      </div>
                      <div
                        className={` did-floating-input sectionInputViewPrint`}
                      >
                        {item?.value ?? ""}
                      </div>

                      {!isViewable &&
                        getError(errors, item.lable, index, i, sf)}
                      {item.hasOwnProperty("hint") && item.hint && (
                          <div
                              className='text-xs text-gray-600 rounded-lg px-2 py-2'
                              dangerouslySetInnerHTML={{
                                __html: item.hint,
                              }}
                          />
                      )}
                    </div>
                  )}
                </>
              );
            }
          })}
        </div>
      </div>
    </>
  );
};

export default SubSectionInputFields;
